import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X, BookOpen } from 'lucide-react';
import CollapsibleInfoTip from './CollapsibleInfoTip';

export const FLIPBOOK_URL = 'https://heyzine.com/flip-book/fc7062b048.html';
export const FLIPBOOK_COVER = 'https://customer-assets-eiarnc6j.emergentagent.net/job_7374e0ed-ecc5-42c0-afaf-3971e1418ffc/artifacts/aeed7ae048234756_cover.jpg';

export const FlipbookModal = ({ onClose, title = 'Retningslinjer for Merkeskyting' }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [onClose]);

  return createPortal(
    <div className="fixed inset-0 z-[130] bg-black/80 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 md:p-6"
      onClick={onClose} data-testid="flipbook-modal-overlay">
      <div className="relative w-full h-full max-w-7xl bg-gray-900 rounded-xl border border-gray-700 shadow-2xl flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()} data-testid="flipbook-modal">
        <div className="flex items-center justify-between gap-3 px-4 py-2.5 border-b border-gray-700 shrink-0">
          <h3 className="text-white font-semibold text-sm sm:text-base flex items-center gap-2 min-w-0">
            <BookOpen className="w-5 h-5 text-yellow-400 shrink-0" />
            <span className="truncate">{title}</span>
          </h3>
          <button type="button" onClick={onClose} aria-label="Lukk"
            className="shrink-0 w-11 h-11 flex items-center justify-center rounded-full bg-white/10 hover:bg-red-500/80 text-white transition-colors touch-manipulation"
            data-testid="flipbook-modal-close">
            <X className="w-6 h-6" />
          </button>
        </div>
        <div className="flex-1 min-h-0 bg-gray-950">
          <iframe
            title={title}
            src={FLIPBOOK_URL}
            allowFullScreen
            allow="autoplay; fullscreen; clipboard-write"
            scrolling="no"
            className="w-full h-full border-0"
            data-testid="flipbook-iframe"
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export const FlipbookTrigger = ({ onOpen }) => (
  <CollapsibleInfoTip prefKey="overview_ekatalog" title="E-katalog: Retningslinjer for Merkeskyting" variant="sky" icon={BookOpen} mobileCollapsed>
  <button type="button" onClick={onOpen}
    className="group flex items-stretch gap-4 w-full -ml-6 p-1 rounded-lg overflow-hidden hover:bg-sky-500/10 transition-colors text-left focus:outline-none focus:ring-2 focus:ring-yellow-400 touch-manipulation"
    data-testid="flipbook-trigger">
    <span className="relative shrink-0 w-24 sm:w-28 aspect-[990/1400] rounded-md overflow-hidden shadow-lg ring-1 ring-white/20">
      <img src={FLIPBOOK_COVER} alt="Retningslinjer for Merkeskyting – e-katalog"
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
    </span>
    <span className="flex flex-col justify-center min-w-0">
      <span className="text-sm text-gray-300 mt-1">En enkel og pedagogisk veileder for medlemmer.</span>
      <span className="mt-3 inline-flex items-center gap-2 self-start px-3 h-9 rounded-lg bg-yellow-500 text-gray-900 text-sm font-semibold group-hover:bg-yellow-400">
        <BookOpen className="w-4 h-4" />Bla i e-katalogen
      </span>
    </span>
  </button>
  </CollapsibleInfoTip>
);

export default FlipbookModal;
